import { Pipe, PipeTransform } from '@angular/core';
import { UtilitysService } from '../../services/utilitys/utilitys.service';

@Pipe({
  name: 'formatCount'
})
export class FormatCountPipe implements PipeTransform {

  constructor(private utility: UtilitysService) {}

  transform(value: any): string {
    if (value === null || value === undefined) return '0';
    const num = Number(value);
    if (isNaN(num)) return value.toString();
    return this.utility.formatCount(num);
  }

}
